import React from "react";
import './student-performance-report.scss';
import SchoolApi from "../../apis/school";
import Dropdown from '../common/dropdown-v2/dropdown';
import CommonApi from "../../apis/common";
import DiagnosticAssessmentReport from "./diagnostic-assessment-report-v1/diagnostic-assessment-report";
import Loading from "../common/loading/loading";
import SectionView from "./sectionView/section-view";
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";

class StudentPerformanceReport extends React.Component {


    state = {
        showShadow: false,
        showFilters: true,
        disableGo: true,

        boardsDropdownItems: [],
        classDropdownItems: [],

        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true,
        selectedStandardHomeworkId: '',
        assessmentTypeDropdownItems: [{ title: 'Diagnostic Report', 'value': 'SECTION' }],
        assessmentTypeDropdownItems_1: [{ title: 'Mock Test Report', 'value': 'SECTION' }],
        showDiagnosticAssessmentReport: false,
        categories: [
            {
                type: "NOVICE",
                title: "Novice",
                maxPercentage: 50,
                students: [],
                colorClass: "purble-header",
                selectedCriterion: 1
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                minPercentage: 50,
                maxPercentage: 80,
                students: [],
                colorClass: "orange-header",
                selectedCriterion: 1
            },
            {
                type: "ADVANCED",
                title: "Advanced",
                minPercentage: 80,
                students: [],
                colorClass: "litebule-header",
                selectedCriterion: 1
            }
        ],
        isLoading: false,
        selectedTab: ''
    }

    classSectionHash = {}

    componentDidMount() {
        this.getClasses()
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                // console.log(school)
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }


    onSelectDropDown = (option, key) => {
        console.log(option, key)
        this.setState({ [key]: option?.value, }, () => {
            this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()

            if (key == "selectedClass" || key == "selectedBoard") {
                this.getSections()
            }
            if (key == 'selectedSection') {
                // console.log(option.sectionId)
                this.setState({ [key]: option?.sectionId, sectionName: option?.title })
                this.getPerformanceReport()
            }

            if (key == 'selectedAssessmentType') {

            }

        })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = "Class 10"
        if (!payload.board) payload.board = "CBSE"

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                console.log(response)
                for (let i = 0; i < response.response.length; i++) {

                    if (response.response[i].section !== 'No Sections') {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                            sectionId: response.response[i]._id
                        })
                    }
                }





                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    getPerformanceReport() {
        let payload = {
            // board: this.state.selectedBoard,
            // class: this.state.selectedClass,
            // section: this.state.selectedSection,
            // type: this.state.selectedAssessmentType
            board: 'CBSE',
            class: 'Class 10',
            type: this.state.selectedTab === 'MATHS' ? 'CLASS_MOCK_TEST' :
                this.state.selectedTab === 'SCIENCE' ? 'SCIENCE_CLASS_MOCK_TEST' :
                    this.state.selectedTab === 'SELECTED_CHAPTER_MOCK_TEST' ? 'SELECTED_CHAPTER_MOCK_TEST' :
                        this.state.selectedTab === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST' ? "SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST" : 'MATHS'
        }


        if (this.state.selectedAssessmentType === 'SECTION' && !this.state.selectedSection) return;

        if (this.state.selectedAssessmentType === 'SECTION' && this.state.selectedSection) {
            payload.section = this.state.selectedSection
        }

        console.log(payload)

        this.setState({ isLoading: true })

        CommonApi.getPerformanceReport(payload).then(res => {
            console.log(res)


            let categories = this.state.categories

            categories.forEach(category => {

                if (category.type === 'NOVICE' && res.noviceStudents && res.noviceStudents.length) {
                    category.students = res.noviceStudents
                }

                if (category.type === 'PROFICIENT' && res.proficientStudents && res.proficientStudents.length) {
                    category.students = res.proficientStudents
                }

                if (category.type === 'ADVANCED' && res.advancedStudents && res.advancedStudents.length) {
                    category.students = res.advancedStudents
                }
            })

            this.setState({ showDiagnosticAssessmentReport: true, categories, reportData: res })
        }).catch(err => {
            this.setState({ isLoading: false })
            console.log(err)
        })

    }

    hideDiagnosticAssessmentReport() {
        this.setState({
            showDiagnosticAssessmentReport: false, isLoading: false, reportData: {},
            categories: [
                {
                    type: "NOVICE",
                    title: "Novice",
                    maxPercentage: 50,
                    students: [],
                    colorClass: "purble-header",
                    selectedCriterion: 1
                },
                {
                    type: "PROFICIENT",
                    title: "Proficient",
                    minPercentage: 50,
                    maxPercentage: 80,
                    students: [],
                    colorClass: "orange-header",
                    selectedCriterion: 1
                },
                {
                    type: "ADVANCED",
                    title: "Advanced",
                    minPercentage: 80,
                    students: [],
                    colorClass: "litebule-header",
                    selectedCriterion: 1
                }
            ]
        })
    }

    showTabDetails(type) {
        this.setState({ selectedTab: type }, () => {
            this.getPerformanceReport()
        })
    }

    showSectionView(type) {
        this.getSections()
        this.setState({ showSectionView: true, selectedTab: type })
    }

    hideSectionView() {
        this.setState({ showSectionView: false, selectedTab: '', selectedAssessmentType: '' })
    }


    renderSectionView() {
        return (
            <div className="new-homwwork-filter">
                {
                    <div>
                        <img alt="" className='back-icon cursor-pointer mb-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.hideSectionView()} />
                    </div>
                }
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Report Type
                                    </div>
                                    <div >
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    placeholder='Select a Section'
                                                    options={this.state.selectedTab === 'MATHS' || this.state.selectedTab === 'SCIENCE' ? this.state.assessmentTypeDropdownItems : this.state.assessmentTypeDropdownItems_1}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedAssessmentType")}
                                                    text={"title"}
                                                    value={this.state.selectedAssessmentType}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section
                                    </div>
                                    <div >
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
                                                    text={"title"}
                                                    value={this.state.selectedSection}

                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>

                            </div>
                        </div> : ""
                }
            </div>
        )
    }




    render() {
        if (this.state.showDiagnosticAssessmentReport) {
            return <DiagnosticAssessmentReport delegate={this}
                class={'Class 10'}
                sectionName={this.state.selectedAssessmentType === 'ALL' ? 'Overall' : this.state.sectionName}
                reportData={{ categories: this.state.categories, ...this.state.reportData }}
                reportType={this.state.selectedTab === 'MATHS' ? 'Maths Diagnostic Assessment' :
                    this.state.selectedTab === 'SCIENCE' ? 'Science Diagnostic Assessment' :
                        this.state.selectedTab === 'SELECTED_CHAPTER_MOCK_TEST' ? 'Maths Mock Test' :
                            this.state.selectedTab === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST' ? "Science Mock Test" : 'Maths Diagnostic Assessment'} />
        }




        return (
            <div className="student-performance-report">
                {
                    this.state.showSectionView ?
                        this.renderSectionView()
                        :
                        <>
                            <div className="report-header">Student Performance Report</div>
                            <div className="d-flex justify-content-around">
                                <div className={`header-wrapper tab-name d-flex justify-content-center align-items-center
                                    ${this.state.selectedTab === 'MATHS' ? 'selected-tab-bg border-left-radius' : ''}`}
                                    onClick={() => this.showSectionView('MATHS')}>Maths Diagnostic Assessment - Free</div>
                                <div className={`header-wrapper tab-name d-flex justify-content-center align-items-center
                                    ${this.state.selectedTab === 'SCIENCE' ? 'selected-tab-bg border-right-radius' : ''}`}
                                    onClick={() => this.showSectionView('SCIENCE')}>Science Diagnostic Assessment - Free </div>
                            </div>
                            <div className="d-flex justify-content-around">
                                <div className={`header-wrapper tab-name d-flex justify-content-center align-items-center
                                    ${this.state.selectedTab === 'MATHS' ? 'selected-tab-bg border-left-radius' : ''}`}
                                    onClick={() => this.showSectionView('SELECTED_CHAPTER_MOCK_TEST')}>Maths Mock Test - 1</div>
                                <div className={`header-wrapper tab-name d-flex justify-content-center align-items-center
                                    ${this.state.selectedTab === 'SCIENCE' ? 'selected-tab-bg border-right-radius' : ''}`}
                                    onClick={() => this.showSectionView('SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST')}>Science Mock Test - 1</div>
                            </div>



                            {/* <div className="new-homwwork-filter">
                                {
                                    !this.state.reload ?
                                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                                            <div className="row">
                                                {
                                                    this.state.boardsDropdownItems.length > 1 ?
                                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                            <div className="filter-input-label">
                                                                Board<span className='text-danger'>*</span>
                                                            </div>
                                                            <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                                <Dropdown
                                                                    placeholder='Select a board'
                                                                    options={this.state.boardsDropdownItems}
                                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                                    text={"title"}
                                                                    value={this.state.selectedBoard}

                                                                />
                                                            </div>
                                                            {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                                        </div>
                                                        : ""
                                                }
                                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                    <div className="filter-input-label">
                                                        Class<span className='text-danger'>*</span>
                                                    </div>
                                                    <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                                        {!this.state.reloadDropdown ?
                                                            <Dropdown
                                                                placeholder='Select a Class'
                                                                options={this.state.classDropdownItems}
                                                                onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                                                text={"title"}
                                                                value={this.state.selectedClass}

                                                            /> : ''}
                                                    </div>
                                                    {this.props.isCreate && !this.state.selectedClass ? <div className='error-text text-danger'>Please Select a class</div> : ''}
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                    <div className="filter-input-label">
                                                        Section
                                                    </div>
                                                    <div >
                                                        {
                                                            !this.state.reloadDropdown ?
                                                                <Dropdown
                                                                    key="class"
                                                                    placeholder='Select a Section'
                                                                    options={this.state.sectionDropdownItems}
                                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
                                                                    text={"title"}
                                                                    value={this.state.selectedSection}

                                                                >
                                                                </Dropdown>
                                                                : ""
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                                    <div className="filter-input-label">
                                                        Report Type
                                                    </div>
                                                    <div >
                                                        {
                                                            !this.state.reloadDropdown ?
                                                                <Dropdown
                                                                    key="class"
                                                                    placeholder='Select a Section'
                                                                    options={this.state.assessmentTypeDropdownItems}
                                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedAssessmentType")}
                                                                    text={"title"}
                                                                    value={this.state.selectedAssessmentType}

                                                                >
                                                                </Dropdown>
                                                                : ""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""
                                }
                            </div> */}
                        </>
                }




            </div>
        )
    }
}

export default StudentPerformanceReport;